"use strict";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export const MAX_WIDTH_MEDIA_BREAKPOINT = "1200px";
export const XLARGE_MEDIA_BREAKPOINT = "960px";
export const SMALL_MEDIA_BREAKPOINT = "540px";
export const MOBILE_MEDIA_BREAKPOINT = "420px";
export const UNSUPPORTED_METADATA_CHAINS = [UniverseChainId.Bnb, UniverseChainId.Avalanche];
